import { render, staticRenderFns } from "./VerifyStep6.vue?vue&type=template&id=ba7bc264&"
import script from "./VerifyStep6.vue?vue&type=script&lang=js&"
export * from "./VerifyStep6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports